import { render, staticRenderFns } from "./monyGroupInput.vue?vue&type=template&id=2741f629"
import script from "./monyGroupInput.vue?vue&type=script&lang=js"
export * from "./monyGroupInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports